import useElysiaStore from '@/app/elysia-store';
import notify from '@/services/notify';
import { EXCEL_GUIDELINES_TOAST_ID } from '@/config/settings';

const openGuidelines = () => useElysiaStore.getState().setShowGuidelinesModal(true);

const isSheetFile = (file: File | string) =>
  /\.(csv|xls|xlsx)$/i.test(typeof file === 'string' ? file : file.name);

// Extra props for a failure toast: adds the "CSV/XLSX file criteria" link for csv/excel files only.
export const sheetAction = (file: File | string) =>
  isSheetFile(file) ? { actionLabel: 'CSV/XLSX file criteria', onAction: openGuidelines } : {};

// Shows the "File guidelines" toast, and opens the modal if the user hasn't acknowledged yet.
export const showSheetGuidelines = (files: File[]) => {
  if (!files.some((file) => isSheetFile(file))) return;

  notify({
    message: 'View the',
    type: 'error',
    actionLabel: 'CSV/XLSX file criteria',
    onAction: openGuidelines,
    toastId: EXCEL_GUIDELINES_TOAST_ID,
  });

  if (useElysiaStore.getState().guidelinesAcknowledged === false) openGuidelines();
};
